import { render, staticRenderFns } from "./MobileWheelOfFortune.vue?vue&type=template&id=1e8f6ed0&scoped=true&"
import script from "./MobileWheelOfFortune.vue?vue&type=script&lang=js&"
export * from "./MobileWheelOfFortune.vue?vue&type=script&lang=js&"
import style0 from "./MobileWheelOfFortune.vue?vue&type=style&index=0&id=1e8f6ed0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8f6ed0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
